<template>
  <a-list-item>
    <a-button
      v-if="currentApprovalStep === step && status === 'SUBMITTING'"
      type="link"
      slot="actions"
      @click="openDrawer"
    >
      <a-icon type="issues-close" /> Approval
    </a-button>

    <a-list-item-meta>
      <div
        slot="description"
        v-if="status === 'SUBMITTING' && currentApprovalStep === step"
      >
        Waiting...
      </div>
      <div slot="description" v-else style="white-space: pre-line;">
        <div v-if="workLeaveApproval && workLeaveApproval.id">
          <span v-if="workLeaveApproval && workLeaveApproval.author">
            {{
              workLeaveApproval.author.fullname ||
              workLeaveApproval.author.username
            }}
          </span>
          <a-divider type="vertical" />
          <span v-if="workLeaveApproval">
            {{ workLeaveApproval.createdAt | formatDateHour }}
          </span>
        </div>
        <div
          v-if="workLeaveApproval && workLeaveApproval.note"
          style="margin-top: 5px;"
        >
          <div>Note / Ghi chú:</div>
          {{ workLeaveApproval.note }}
        </div>
      </div>

      <div slot="title">
        <BadgeProcessApproval
          :approvalStatus="workLeaveApproval.approvalStatus"
          :currentApprovalStep="currentApprovalStep"
          :step="step"
          :status="status"
        />
        <span> {{ department }} </span>
      </div>
    </a-list-item-meta>
    <span slot="extra" v-if="workLeaveApproval">
      <BadgeStatusApproval
        :status="status"
        :approvalStatus="workLeaveApproval.approvalStatus"
      />
    </span>
  </a-list-item>
</template>
<script>
import BadgeProcessApproval from "./badgeProcessApproval";
import BadgeStatusApproval from "./badgeStatusApproval";
export default {
  components: { BadgeProcessApproval, BadgeStatusApproval },
  props: {
    workLeaveApproval: {
      type: Object,
      required: true,
    },
    department: {
      type: String,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
    openDrawer: {
      type: Function,
    },
    currentApprovalStep: {
      type: Number,
    },
    status: {
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
